module.exports = __webpack_public_path__ + "static/media/hright.d8f7fafb.png";